import type { AnalyticsSection } from '@sia/analytics-contracts';

export type SectionDefinition = {
  id: AnalyticsSection;
  path: string;
  title: string;
  shortTitle: string;
  description: string;
  groupFilter: boolean;
};

export const sections: SectionDefinition[] = [
  { id: 'overview', path: '/', title: 'Overview', shortTitle: 'Overview', description: 'Fixed headline numbers spanning the full history. This page does not react to a date range — it is always Day 0 → today.', groupFilter: false },
  { id: 'global-usage', path: '/global-usage', title: 'Global usage', shortTitle: 'Global usage', description: 'Reach and retention across the whole user base, for the selected range. Active = at least one logged event in the window.', groupFilter: false },
  { id: 'average-per-user', path: '/average-per-user', title: 'Average per-user', shortTitle: 'Average per-user', description: 'Platform-wide behavior per active user — mean and median side by side so outliers are visible. Denominator is users active in the selected range.', groupFilter: false },
  { id: 'preference-profiles', path: '/preference-profiles', title: 'Preference profiles', shortTitle: 'Preference profiles', description: 'What users are searching for and where — the demand-side dataset behind the market-intelligence pitch.', groupFilter: false },
  { id: 'listing-inventory', path: '/inventory', title: 'Inventory', shortTitle: 'Inventory', description: 'The consolidated cross-source inventory — the thing no single Hebrew platform offers newcomers.', groupFilter: true },
  { id: 'alerts-engagement', path: '/alerts', title: 'Alerts', shortTitle: 'Alerts', description: 'The core promise: a matching listing reaches the user quickly. This section tracks volume, open behavior, and opt-outs by channel.', groupFilter: false },
  { id: 'scraper-health', path: '/scraper-health', title: 'Scraper health', shortTitle: 'Scraper health', description: 'Pipeline integrity for the two metrics that matter most operationally: is a source failing, and how long do runs take.', groupFilter: false },
];

export const plannedSections = [
  {
    path: '/lifecycle-intent',
    title: 'Lifecycle & intent',
    description: 'Modeling where each user sits in their rental journey — tenure, rental cycles, dormant/reactivated states, and rising-budget signals.',
    items: [
      'Dormant → reactivated → churned state machine',
      'Rental cycles per user across seasons',
      'Budget-ceiling drift across profile edits',
      'Consent-gated; individual intent stays aggregate',
    ],
  },
  {
    path: '/market-intelligence',
    title: 'Market intelligence',
    description: 'The saleable, anonymized demand dataset — the layer that turns Sia’s traffic into a product for developers, universities, and agencies.',
    items: [
      'Demand heatmap by neighborhood',
      'Unmet demand: high search, thin supply',
      'Affordability index: asking rent vs user budget',
      'Minimum group size enforced before any export',
    ],
  },
  {
    path: '/data-quality',
    title: 'Data quality',
    description: 'Internal integrity checks that keep every other number trustworthy.',
    items: [
      'Listings missing city / price / coordinates',
      'FB posts dropped as non-listings by the LLM filter',
      'Duplicate rate caught vs suspected-missed',
      'Users missing residency metadata',
    ],
  },
];
